/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const es_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const de_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const nl_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const fr_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const it_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const pt_br2_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const pt_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy`)
};

const ja_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジー`)
};

const zh_tool_f1_fantasy_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1梦幻赛车`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tool_f1_fantasy_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tool_f1_fantasy_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tool_f1_fantasy_name", locale)
	if (locale === "en") return en_tool_f1_fantasy_name(inputs)
	if (locale === "es") return es_tool_f1_fantasy_name(inputs)
	if (locale === "de") return de_tool_f1_fantasy_name(inputs)
	if (locale === "nl") return nl_tool_f1_fantasy_name(inputs)
	if (locale === "fr") return fr_tool_f1_fantasy_name(inputs)
	if (locale === "it") return it_tool_f1_fantasy_name(inputs)
	if (locale === "pt-BR") return pt_br2_tool_f1_fantasy_name(inputs)
	if (locale === "pt") return pt_tool_f1_fantasy_name(inputs)
	if (locale === "ja") return ja_tool_f1_fantasy_name(inputs)
	return zh_tool_f1_fantasy_name(inputs)
};